<h1>Equipos</h1>
<div class="container">
  <form [formGroup]="filterColumForm" class="form">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label> Filtro Específico </mat-label>
      <mat-select formControlName="filterDetails" (selectionChange)="cleanFilter()"
        matTooltip="Filtro por una columna de la tabla" matTooltipPosition="above">
        <mat-option value="0">Seleccione...</mat-option>
        <mat-option value="group" matTooltip="Filtro por la columna Agrupación" matTooltipPosition="right">Agrupación
        </mat-option>
        <mat-option value="description" matTooltip="Filtro por la columna Descripción" matTooltipPosition="right">Descripción
        </mat-option>
        <mat-option value="reference" matTooltip="Filtro por la columna Referencia" matTooltipPosition="right">Referencia
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always" matTooltip="Valor a filtrar por columna seleccionada"
      matTooltipPosition="above" class="input-width-28vw">
      <mat-label>Valor</mat-label>
      <input matInput placeholder="Valor a filtrar..." formControlName="descriptionFilter" (keyup)="resetPaginator($event)"
        #input2>
      <mat-error *ngIf="filterColumForm.controls['descriptionFilter'].hasError('minlength')">Mínimo 3 caracteres.</mat-error>
      <mat-error *ngIf="filterColumForm.controls['descriptionFilter'].hasError('maxlength')">Máximo 100
        caracteres.</mat-error>
    </mat-form-field>
<button mat-raised-button color="primary" type="button" (click)="applyFilterDetails()"
  [disabled]="disableButtonfilter">Filtrar</button>
</form>
<div class="espacio-div-20"></div>
<form [formGroup]="filterSearchForm" class="form" fxHide.xs fxHide.sm fxHide.md>
  <mat-form-field appearance="outline" floatLabel="always" matTooltip="Filtro por cualquier columna de la tabla"
    matTooltipPosition="above" class="input-width-28vw">
    <mat-label> Filtro General </mat-label>
    <input matInput placeholder="Valor a filtrar..." formControlName="descriptionSearch" (keyup)="resetPaginator($event)"
      #input>
    <mat-error *ngIf="filterSearchForm.controls['descriptionSearch'].hasError('minlength')">Mínimo 3 caracteres.</mat-error>
    <mat-error *ngIf="filterSearchForm.controls['descriptionSearch'].hasError('maxlength')">Máximo 100
      caracteres.</mat-error>
    </mat-form-field>
    <button mat-raised-button color="primary" type="button" (click)="applyFilter()"
      [disabled]="disableButtonSearch">Filtrar</button>
    </form>
</div>
<div class="espacio-div-20" fxHide.lg fxHide.xl></div>
<div class="table-overflow-100">
  <table mat-table [dataSource]="dataSourceFilters" matSort matSortActive="reference" matSortDirection="asc"
    matSortDisableClear class="mat-elevation-z8">
    <ng-container matColumnDef="reference">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Referencia </th>
      <td mat-cell *matCellDef="let element" align="center"> {{element.reference}} </td>
    </ng-container>
    <ng-container matColumnDef="updateDate">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Fecha </th>
      <td mat-cell *matCellDef="let element" align="center"> {{element.updateDate | date:'dd/MM/yyyy'}} </td>
    </ng-container>
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Descripción </th>
      <td mat-cell *matCellDef="let element"> {{element.description}} </td>
    </ng-container>
    <ng-container matColumnDef="price">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Precio/Alquiler </th>
      <td mat-cell *matCellDef="let element" align="right"> {{element.price | number:'1.2-2':'es'}} </td>
    </ng-container>
    <ng-container matColumnDef="depreciationCOP">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> COP/Dep. </th>
      <td mat-cell *matCellDef="let element" align="right"> {{element.depreciationCOP | number:'1.6-6':'es'}} </td>
    </ng-container>
    <ng-container matColumnDef="dailyPrice">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Costo Diario </th>
      <td mat-cell *matCellDef="let element" align="right"> {{element.price * element.depreciationCOP | number:'1.2-2':'es'}} </td>
    </ng-container>
    <ng-container matColumnDef="addedValue">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> V.A.N. </th>
      <td mat-cell *matCellDef="let element" align="right"> {{element.addedValue | number:'1.2-2':'es'}} </td>
    </ng-container>
    <ng-container matColumnDef="group">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Agrupación </th>
      <td mat-cell *matCellDef="let element"> {{element.group}} </td>
    </ng-container>
    <ng-container matColumnDef="supplierName">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Proveedor </th>
      <td mat-cell *matCellDef="let element"> {{element.supplierName}} </td>
    </ng-container>
    <ng-container matColumnDef="dollarPrice">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Precio/Alquiler $ </th>
      <td mat-cell *matCellDef="let element" align="right"> {{element.dollarPrice | number:'1.2-2':'es'}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="mat-header-medium"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
      (click)="verDetalle(row)"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="11">No hay data que filtrar</td>
    </tr>
  </table>
</div>
<mat-paginator #paginator [length]="totalItemsPage" [pageSizeOptions]="[25, 50, 100]"
  showFirstLastButtons></mat-paginator>
